/* eslint-disable @typescript-eslint/typedef */
import { Observable } from 'rxjs';

export const AuthContextNames = [
  'app',           // legacy mobile app
  'login',         // lekkerland sso
  'public',        // without login
] as const;

export type AuthContextType = typeof AuthContextNames[number];
export type AuthTokenType = 'user' | 'llDirectoryUser';
export type CheckAuthStateResult = 'success' | 'agentNoUserId' | 'notLoggedIn';

export function isAuthContextType(value: unknown): value is AuthContextType {
  return AuthContextNames.includes(value as AuthContextType);
}

export interface AuthToken {
  userId: string;
  agentId?: string;
  bearer: string;
  expires: string | number;
  refreshToken?: string;
  refreshTokenExpires?: string | number;
  type?: AuthTokenType;
  roles?: string[];
  // MSAL audience claim — equals the clientId of the app that requested the
  // token. Used by the BFF to map the calling app to a required CAPS permission.
  audience?: string;
}

export interface ConnectionAuthModel {
  token?: AuthToken;
  customerNumber?: string;
}

export abstract class ConnectionAuthProvider {
  public abstract getAuth(): Observable<ConnectionAuthModel>;

  public abstract getAuthRaw(): ConnectionAuthModel;

  // Ignores customer state and returns token-only connection auth
  public abstract getTokenBasedAuth(): Observable<ConnectionAuthModel>;
}
